import type { CallsenseScoreField } from '@utazzo/shared';

export const SCORE_LABELS: Record<CallsenseScoreField, string> = {
  politeness_score: 'Politeness',
  greeting_score: 'Greeting',
  empathy_score: 'Empathy',
  active_listening_score: 'Active listening',
  product_knowledge_score: 'Product knowledge',
  needs_identification_score: 'Needs identification',
  objection_handling_score: 'Objection handling',
  upsell_cross_sell_score: 'Upsell / cross-sell',
  call_control_score: 'Call control',
  closing_score: 'Closing',
  language_clarity_score: 'Language clarity',
};

export const OUTCOME_LABELS: Record<string, string> = {
  booked: 'Booked',
  quote_sent: 'Quote sent',
  follow_up_needed: 'Follow-up needed',
  not_interested: 'Not interested',
  info_only: 'Info only',
  complaint: 'Complaint',
  other: 'Other',
};

export const OUTCOME_COLORS: Record<string, string> = {
  booked: '#10b981',
  quote_sent: '#3b82f6',
  follow_up_needed: '#f59e0b',
  not_interested: '#94a3b8',
  info_only: '#8b5cf6',
  complaint: '#f43f5e',
  other: '#64748b',
};

export const SENTIMENT_COLORS: Record<string, string> = {
  positive: '#10b981',
  neutral: '#94a3b8',
  negative: '#f43f5e',
};

/** 0-100 overall score -> text tone class. */
export const scoreToneClass = (score: number | null | undefined): string => {
  if (score == null) return 'text-muted-foreground';
  if (score >= 80) return 'text-emerald-600 dark:text-emerald-400';
  if (score >= 60) return 'text-amber-600 dark:text-amber-400';
  return 'text-rose-600 dark:text-rose-400';
};

/** 1-5 dimension score -> bar color class. */
export const dimensionBarClass = (score: number | null | undefined): string => {
  if (score == null) return 'bg-muted';
  if (score >= 4) return 'bg-emerald-500';
  if (score >= 3) return 'bg-amber-500';
  return 'bg-rose-500';
};

export const formatMinutes = (minutes: number | null | undefined): string => {
  if (minutes == null) return '-';
  const whole = Math.floor(minutes);
  const seconds = Math.round((minutes - whole) * 60);
  return `${whole}m ${String(seconds).padStart(2, '0')}s`;
};

export const formatCallDate = (iso: string | null): string =>
  iso
    ? new Date(iso).toLocaleString('en-IN', {
        dateStyle: 'medium',
        timeStyle: 'short',
        timeZone: 'Asia/Kolkata',
      })
    : '-';

export const percent = (ratio: number): string => `${Math.round(ratio * 100)}%`;
